import { ITaggingFlowOption } from 'interfaces/tagging/ITaggingFlowOption';
import { HitTypes } from '@trackman/baseball-shared-components';

export const HitOptions: ITaggingFlowOption[] = [
  {
    displayName: 'Ground Ball',
    value: HitTypes.GroundBall,
    hotkeyCode: 71,
    hotkeyDisplay: 'G',
  },
  {
    displayName: 'Line Drive',
    value: HitTypes.LineDrive,
    hotkeyCode: 76,
    hotkeyDisplay: 'L',
  },
  {
    displayName: 'Fly Ball',
    value: HitTypes.FlyBall,
    hotkeyCode: 70,
    hotkeyDisplay: 'F',
  },
  {
    displayName: 'Popup',
    value: HitTypes.Popup,
    hotkeyCode: 80,
    hotkeyDisplay: 'P',
  },
  {
    displayName: 'Bunt',
    value: HitTypes.Bunt,
    hotkeyCode: 66,
    hotkeyDisplay: 'B',
  },
];
